module.exports = __webpack_public_path__ + "static/media/image_dancers_web.46c66461.png";